/*
 * View responsible for the quick create assoc. content modal.  Allows an author
 * to create a new piece of content and apply it to a topic in one step.
 */

define([
  "marionette",
  "modules/quickCreate/quickContentModal/template/quickContentModalTemplate.html",
], function (Marionette, QuickContentModalTemplate) {
  var QuickContentModalView = {};

  QuickContentModalView.quickContentModalLayout = Marionette.Layout.extend({
    template: QuickContentModalTemplate,
    clearError: function () {
      this.$el.find("#contentError").html("");
    },
    getCompleteness: function () {
      return this.$el.find("#completeness").prop("checked");
    },
    regions: {
      editor: "#contentEditor",
      currentContent: "#currentContent",
    },
    showContentError: function (errorMessage) {
      this.$el
        .find("#contentError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return QuickContentModalView;
});
